<template>
  <div>
    <div style="margin-bottom: 15px;">
      <div style="float:left;width:20%;">
        <img src="../../../assets/show/index_m1.jpg" />
      </div>
      <div style="float:right;width:80%;padding-left:38px">
        <a-dropdown>
          <a-button icon="read" @mouseenter="ScienceEnter">科技展鹏</a-button>
        </a-dropdown>
        <a-dropdown>
          <a-button icon="read">经营主体</a-button>
          <a-menu slot="overlay">
            <a-menu-item>
              <a target="_blank" rel="noopener noreferrer" href="http://www.alipay.com/">家庭农场</a>
            </a-menu-item>
            <a-menu-item>
              <a target="_blank" rel="noopener noreferrer" href="http://www.taobao.com/">农村合作社</a>
            </a-menu-item>
            <a-menu-item>
              <a target="_blank" rel="noopener noreferrer" href="http://www.tmall.com/">龙头合作社</a>
            </a-menu-item>
            <a-menu-item>
              <a target="_blank" rel="noopener noreferrer" href="http://www.tmall.com/">服务组织</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <a-dropdown>
          <a-button icon="read" @mouseenter="MachineryServerEnter">农机服务</a-button>
        </a-dropdown>
        <a-dropdown>
          <a-button icon="read" @mouseenter="RuralTalentsEnter">农村人才</a-button>
        </a-dropdown>
        <a-dropdown>
          <a-button icon="read" @mouseenter="FinanciaEnter">金融报销</a-button>
        </a-dropdown>
      </div>
      <div v-show="this.btnType === this.Type[0]" style="background:#fff; width:80%;float:right">
        <a-list bordered :data-source="listData">
          <a-list-item v-for="(item, index) of listData" :key="index" :value="item.title">
            <a @click="TextcontentClick(item.id)" style="color:#000">
              <span style="float:left">{{ item.title }}</span>
            </a>
            <a @click="TextcontentClick(item.id)" style="color:#000">
              <span style="float:right">{{ item.publishTime }} </span>
            </a>
          </a-list-item>
        </a-list>
      </div>
      <div v-show="this.btnType === this.Type[2]" style="background:#fff; width:80%;float:right">
        <a-table :columns="columns" :data-source="FarmMachineData" :pagination="pagination"> </a-table>
      </div>
      <div v-show="this.btnType === this.Type[3]" style="background:#fff; width:80%;float:right">
        <button class="smallBtn">
          <span>农村劳务</span>
        </button>
        <button class="smallBtn" @mouseenter="TalentsEnter">
          <span>专业人才</span>
        </button>
      </div>
      <!-- -->
      <div v-show="this.btnType === this.Type[4]" style=" width:80%;float:right;">
        <citysearch-Box title="农业贷款" SdType="10" style="float:left;width:49%;"></citysearch-Box>
        <citysearch-Box title="农业保险" tType="11" style="float:right;width:49%"></citysearch-Box>
        <div style="clear: both"></div>
      </div>
      <div v-show="this.btnType === this.Type[3] && this.bottombtnType === this.BottomType[1]" style="background:#fff; width:80%;float:right">
        <a-table :columns="Talentscolums" :data-source="TalentsInfoData" :pagination="pagination"> </a-table>
      </div>
      <div style="float:right;"><span style="font-weight:600;" @click="MachineryClick">更多》</span></div>
      <div style="clear:both"></div>
    </div>
  </div>
</template>
<script>
import { InfoMainWebPage } from '@/api/main/InfoMainManage'
import { FarmMachineInformationWebPage } from '@/api/main/FarmMachineInformationManage'
import { TalentsInfoWebPage } from '@/api/main/TalentsInfoManager'
import citysearchBox from '@/layouts/topBox/cityBox/citysearchBox.vue'
export default {
  components: {
    citysearchBox
  },
  data() {
    return {
      topitem: false,
      Machineryitem: true,
      infoType: '',
      FarmMachineData: [],
      pagination: {
        pagesize: 6
        },
      listData: [],
      columns: [
        {
          title: '农机所有人',
          dataIndex: 'fName',
          width: 140
        },
        {
          title: '农机具类型',
          dataIndex: 'mType',
          width: 140
        },
        {
          title: '农机具型号',
          dataIndex: 'modelNumber',
          width: 140
        },
        {
          title: '作业单价',
          dataIndex: 'price',
          width: 140
        },
        {
          title: '发布日期',
          dataIndex: 'publishDate',
          width: 140
        }
      ],
      Talentscolums: [
        {
          title: '姓名',
          dataIndex: 'name',
          width: 140
        },
        {
          title: '性别',
          dataIndex: 'gender',
          width: 140
        },
        {
          title: '专业专长',
          dataIndex: 'expertise',
          width: 140
        },
        {
          title: '从业年限',
          dataIndex: 'numberOfYears',
          width: 140
        },
        {
          title: '意向服务地区',
          dataIndex: 'areaOfInterest',
          width: 140
        },
        {
          title: '发布日期',
          dataIndex: 'createTime',
          width: 140
        }
      ],
      /** 1.科技展翅，2 经营主体，3 农机服务，4 农村人才，5金融报销 */
      Type: ['科技展翅', '经营主体', '农机服务', '农村人才', '金融报销'],
      BottomType: ['农村劳务', '专业人才'],
      btnType: '',
      bottombtnType: '',
      TalentsInfoData: []
    }
  },
  created() {
    this.ScienceEnter()
  },
  methods: {
    loadData() {
      InfoMainWebPage({ orgId: this.orgId, infoType: this.infoType }).then(res => {
        this.listData = ''
        this.listData = res.data.rows
      })
    },
    btnView() {
      this.topitem = false
      this.Machineryitem = true
      if (this.btnType) {
      }
    },
    ScienceEnter() {
      this.infoType = 5
      this.btnType = this.Type[0]
      this.loadData()
    },
    MachineryServerEnter() {
      this.btnType = this.Type[2]
      FarmMachineInformationWebPage().then(res => {
        this.FarmMachineData = res.data.rows
      })
    },
    RuralTalentsEnter() {
      this.btnType = this.Type[3]
    },
    FinanciaEnter() {
      this.btnType = this.Type[4]
    },
    TalentsEnter() {
      this.bottombtnType = this.BottomType[1]
      TalentsInfoWebPage().then(res => {
        this.TalentsInfoData = res.data.rows
      })
    },
    MachineryClick() {
      const go = this.$router.resolve('/Farm_Machine_CooperatimeList')
      window.open(go.href, '_blank')
    },
    TextcontentClick(id) {
      const go = this.$router.resolve({ path: 'Textcontent', query: { id } })
      window.open(go.href, '_blank')
    }
  }
}
</script>
<style scoped>
.ant-btn {
  float: left;
  width: 170px;
  height: 75px;
  font-family: Arial;
  font-weight: 800;
  font-size: 16px;
  margin-left: 5px;
  background: #e6dfcf;
}
.ant-btn:hover {
  color: #fff;
  background: #207e63;
}
.ant-btn:focus {
  color: #fff;
  background: #207e63;
}
.ant-btn:first {
  margin-left: 200px;
}
.smallBtn {
  width: 115px;
  height: 40px;
}
</style>
